module.exports = __webpack_public_path__ + "static/media/mma-logo2.8c8d4840.png";